import React, { useMemo } from "react";
import { OptionDropdown } from "@/components/ui/OptionDropdown";
import type { DropdownOption } from "@/components/ui/OptionDropdown";
import {
  LeadStatus,
  LEAD_STATUS_CONFIG,
  LEAD_STATUS_TRANSITIONS,
} from "../Lead.types";

interface LeadStatusBadgeProps {
  status: LeadStatus;
  onStatusChange?: (status: LeadStatus) => void;
  /** Limit the menu to LEAD_STATUS_TRANSITIONS instead of every status. */
  transitionsOnly?: boolean;
  disabled?: boolean;
  align?: "left" | "right";
}

function toOption(status: LeadStatus): DropdownOption<LeadStatus> {
  const cfg = LEAD_STATUS_CONFIG[status];
  return {
    value: status,
    label: cfg.label,
    bg: cfg.bgColor,
    text: cfg.color,
    dot: cfg.dot,
  };
}

const ALL_OPTIONS = (Object.keys(LEAD_STATUS_CONFIG) as LeadStatus[]).map(
  toOption
);

export const LeadStatusBadge: React.FC<LeadStatusBadgeProps> = ({
  status,
  onStatusChange,
  transitionsOnly = false,
  disabled = false,
  align = "left",
}) => {
  const options = useMemo(
    () =>
      transitionsOnly
        ? [status, ...LEAD_STATUS_TRANSITIONS[status]].map(toOption)
        : ALL_OPTIONS,
    [transitionsOnly, status]
  );

  const isInteractive =
    !!onStatusChange && (!transitionsOnly || options.length > 1);

  return (
    <OptionDropdown
      value={status}
      options={options}
      onChange={isInteractive ? onStatusChange : undefined}
      disabled={disabled}
      align={align}
    />
  );
};
